import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import {
  RadioGroup,
  RadioGroupItem,
} from "@babackapp/customer-ui/components/radio-group";
import type { Resolution } from "@babackapp/return-widget-components/types";
import { RefreshCcw, StoreIcon } from "lucide-react";
import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import { VariantFooter } from "./variant-footer";

type ExchangeResolution = Extract<Resolution, "exchange" | "exchange-credit">;

type Props = {
  value: ExchangeResolution | null;
  onChange: (value: ExchangeResolution) => void;
  orderId: string;
  lineItemId: string;
  shopId: string;
  exchangeVariantId: string | null;
  onVariantChange: (variantId: string | null) => void;
  exchangeVariantAvailable?: boolean;
};

export function ExchangeOptions({
  value,
  onChange,
  orderId,
  lineItemId,
  shopId,
  exchangeVariantId,
  onVariantChange,
  exchangeVariantAvailable = true,
}: Props) {
  const t = useCustomText();
  return (
    <OptionsList>
      <RadioGroup
        value={value ?? ""}
        onValueChange={(v) => onChange(v as ExchangeResolution)}
      >
        {exchangeVariantAvailable && (
          <Label htmlFor="exchange-variant">
            <Option>
              <OptionIcon>
                <RefreshCcw />
              </OptionIcon>
              <OptionTitle>{t("exchangeOptions.variant.title")}</OptionTitle>
              <OptionDescription>
                {t("exchangeOptions.variant.description")}
              </OptionDescription>
              <OptionAction>
                <RadioGroupItem value="exchange" id="exchange-variant" />
              </OptionAction>
              {value === "exchange" && (
                <VariantFooter
                  orderId={orderId}
                  lineItemId={lineItemId}
                  shopId={shopId}
                  onVariantChange={onVariantChange}
                />
              )}
            </Option>
          </Label>
        )}
        <Label htmlFor="exchange-credit">
          <Option>
            <OptionIcon>
              <StoreIcon />
            </OptionIcon>
            <OptionTitle>{t("exchangeOptions.credit.title")}</OptionTitle>
            <OptionDescription>
              {t("exchangeOptions.credit.description")}
            </OptionDescription>
            <OptionAction>
              <RadioGroupItem value="exchange-credit" id="exchange-credit" />
            </OptionAction>
          </Option>
        </Label>
      </RadioGroup>
    </OptionsList>
  );
}
